import { type QueryHookOptions, useQuery } from "@apollo/client";
import { UsageHistoryQuery } from "../graphql/queries";
import type {
  UsageHistoryQueryType,
  UsageHistoryQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useUsageHistoryQuery = (
  options?: QueryHookOptions<
    UsageHistoryQueryType,
    UsageHistoryQueryVariablesType
  >
) => {
  return useQuery<UsageHistoryQueryType, UsageHistoryQueryVariablesType>(
    UsageHistoryQuery,
    { fetchPolicy: "cache-and-network", ...options }
  );
};
